import { format } from 'date-fns';
import { v4 as uuidv4 } from 'uuid';
import ADLER32 from 'adler-32';

const url = () => {
  const origin = window.location.origin;
  const path = '/logingress/v1/logs';
  return `${origin}${path}`;
};

const locationUrl = () => {
  try {
    return window.location.href;
  } catch (e) {
    console.error(e);
    return null;
  }
};

const generateParams = () => {
  return {
    log_id: `ai-smartphone-sushiro-${uuidv4()}`,
    event_time: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"),
    service_name: 'serv_ai_inquiry',
    app_name: 'app_ai_smartphone_sushiro',
    user_agent: navigator.userAgent,
    url: locationUrl(),
  };
};

const CHECKSUM_V1_SEED = 'ubie123';
const CHECKSUM_VERSION = '1';

const generateChecksumHeaders = (data: string) => {
  let checksum = ADLER32.str(CHECKSUM_V1_SEED + data);
  // To unsigned.
  checksum = checksum >>> 0;
  return {
    'X-Checksum': checksum.toString(),
    'X-Checksum-Version': CHECKSUM_VERSION,
  };
};

type PostLogingressParameter = {
  log_type: string;
};

export const postLogingress = async <T extends PostLogingressParameter>(params: T) => {
  const baseParams = generateParams();
  const sendParams = {
    ...params,
    ...baseParams,
  };

  if (process.env.NODE_ENV === 'development') {
    console.log('Logingress params', sendParams);
    return;
  }

  try {
    // logingressへはArrayで送る
    const requestData = JSON.stringify([sendParams]);
    await fetch(url(), {
      body: requestData,
      headers: {
        'Content-Type': 'application/json',
        ...generateChecksumHeaders(requestData),
      },
      method: 'POST',
      keepalive: true,
    });
  } catch (err) {
    console.error(err);
  }
};
